import React, { useState } from 'react';
import { useDroppable } from '@dnd-kit/react';

import TimelineCreateMemoryAsset from './MemoryAsset';

import type { Asset } from '../../types/asset';

interface TimelineCreateMemoryAssetsProps {
  id: string;
  assets: Asset[];
  hovered: boolean;
  disabled: boolean;
  errors: any;
  handleRemoveFile: Function;
  handleSplitFiles: Function;
};

const TimelineCreateMemoryAssets: React.FC<TimelineCreateMemoryAssetsProps> = ({
  id,
  assets,
  hovered,
  disabled,
  errors,
  handleRemoveFile,
  handleSplitFiles,
}) => {
  const [splitMode, setSplitMode] = useState(false);
  const [selectedAssets, setSelectedAssets] = useState([] as string[]);

  const { ref } = useDroppable({
    id: `memory-${id}`,
    type: 'column',
    accept: ['item'],
    disabled: splitMode || disabled,
  });

  const getErrorForField = (fieldName: string) => {
    const error = errors ? errors.find((err: any) => err.path.includes(fieldName)) : null;
    return error ? error.message || null : null;
  };

  const switchSplitMode = () => {
    if (splitMode) {
      setSelectedAssets([]);
    }
    setSplitMode(!splitMode);
  };

  const switchSelectedAsset = (assetId: string) => {
    if (selectedAssets.includes(assetId)) {
      setSelectedAssets(selectedAssets.filter(id => id !== assetId));
    } else {
      setSelectedAssets([...selectedAssets, assetId]);
    }
  };

  const splitFiles = () => {
    handleSplitFiles(selectedAssets);
    setSelectedAssets([]);
    setSplitMode(false);
  };

  return (
    <>
      <div className={`timeline-memory-assets memory-files-grid wa-cluster wa-gap-xs${hovered ? ' hovered' : ''}`} ref={ref}>
        {assets.map((asset, index) => (
          <TimelineCreateMemoryAsset
            key={asset.id}
            asset={asset}
            index={index}
            memoryId={id}
            splitMode={splitMode}
            disabled={disabled}
            selected={selectedAssets.includes(asset.id)}
            switchSelectedAsset={switchSelectedAsset}
            handleRemoveFile={handleRemoveFile}
          />
        ))}
      </div>
      {getErrorForField('assets') && (
        <div className="error-message">
          {getErrorForField('assets')}
        </div>
      )}
      {(assets.length > 0 && !disabled) && (
        <div className="wa-cluster wa-gap-xs">
          {splitMode ? (
            <>
              <wa-button key="confirm-split" size="xs" appearance="accent" onClick={splitFiles} disabled={selectedAssets.length === 0}>
                Confirm split ({selectedAssets.length} selected)
              </wa-button>
              <wa-button key="cancel-split" size="xs" appearance="outlined" onClick={switchSplitMode}>
                Cancel
              </wa-button>
            </>
          ) : (
            <wa-button key="split-memory" size="xs" appearance="outlined" onClick={switchSplitMode}>
              Split into separate memory
            </wa-button>
          )}
        </div>
      )}
    </>
  );
};

export default TimelineCreateMemoryAssets;
